import { render } from "./MallManagerInfo.vue?vue&type=template&id=06e251ee&scoped=true"
import script from "./MallManagerInfo.vue?vue&type=script&lang=js"
export * from "./MallManagerInfo.vue?vue&type=script&lang=js"

import "./MallManagerInfo.vue?vue&type=style&index=0&id=06e251ee&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e251ee"]])

export default __exports__